export default "__VITE_ASSET__d3d64b97__"